/* eslint-disable
max-len,
no-mixed-spaces-and-tabs,
react/jsx-indent,
react/jsx-first-prop-new-line,
*/

import React, { PureComponent, PropTypes } from 'react';
import styles from './styles.scss';

export class Employee extends PureComponent {
  render() {
    return (
      <div className={this.props.className}>
        <svg version="1.1" id="Dude" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 226 428" preserveAspectRatio="xMaxYMax slice" xmlSpace="preserve">
        <g>
          <path className={styles.st0}
            d="M103.5,364.6l8,2.1c3.2,0.9,5,4.4,4.1,7.9l-6.7,25.2c-0.9,3.5-3.3,2.1-6.5,1.3l-8-2.1c-3.2-0.9-5.5-2.5-6-0.9l6.3-23.5C97,365.9,100.4,363.7,103.5,364.6z"
          />
          <path className={styles.st1}
            d="M87.6,392.9l-3.8,18.2l51.8,13.8l1.4-5.1c0.9-3.5-0.6-7.1-3.7-8.8l-22.8-12.7c-3.3,0.5-7.8,0.1-12.6-1.2C93.7,396.1,90.1,394.6,87.6,392.9z"
          />
          <g>
            <defs>
              <path id="SVGID_1_"
                d="M87.6,392.9l-3.8,18.2l51.8,13.8l1.4-5.1c0.9-3.5-0.6-7.1-3.7-8.8l-22.8-12.7c-3.3,0.5-7.8,0.1-12.6-1.2C93.7,396.1,90.1,394.6,87.6,392.9z"
              />
            </defs>
            <clipPath id="SVGID_2_">
              <use xlinkHref="#SVGID_1_" className={styles.st17} />
            </clipPath>
            <g className={styles.st2}>
              <g>
                <line className={styles.st3} x1="138.1" y1="406.8" x2="125.3" y2="410.4" />
                <line className={styles.st3} x1="127.9" y1="404.1" x2="117.2" y2="407" />
                <line className={styles.st3} x1="117.7" y1="401.3" x2="110.3" y2="403.4" />
              </g>

                <ellipse transform="matrix(0.2579 -0.9662 0.9662 0.2579 -334.5025 382.3282)" className={styles.st3} cx="81.6" cy="408.9" rx="9.8" ry="9.8" />
            </g>
          </g>

            <rect x="83.2" y="414" transform="matrix(-0.9662 -0.2579 0.2579 -0.9662 109.2394 846.3716)" className={styles.st4} width="53.8" height="4.1" />

            <ellipse transform="matrix(0.877 -0.4805 0.4805 0.877 -63.5451 84.3209)" className={styles.st5} cx="132.9" cy="166.3" rx="10.3" ry="10.3" />
          <polygon className={styles.st5} points="123.9,171.2 142,161.3 108.8,94.8 85.6,107.5 " />
          <polygon className={styles.st6} points="108,153.9 128.8,132.3 108.8,94.8 85.6,107.5 " />
          <polygon className={styles.st5} points="214.7,162 212.3,146.1 130.8,156.1 133.9,176.5 " />
          <path className={styles.st0}
            d="M49.3,374.5h8.3c3.3,0,6,2.9,6,6.5v26c0,3.6-2.7,2.9-6,2.9h-8.3c-3.3,0-6-1-6,0.7v-24.3C43.3,377.4,45.9,374.5,49.3,374.5z"
          />
          <path className={styles.st5}
            d="M224.3,152.1L224.3,152.1c-0.8-5.3-5.7-8.9-11-8.1l-7.1,1.1c-3.7,0.6-6.2,4-5.6,7.6l0.9,5.8c0.6,3.7,4,6.2,7.6,5.6l7.1-1.1C221.5,162.3,225.1,157.4,224.3,152.1z"
          />
          <path className={styles.st1}
            d="M41.1,406l1.1,18.6h53.6v-5.3c0-3.6-2.4-6.7-5.9-7.6l-25.3-6.3c-3,1.3-7.5,2.1-12.5,2.1C47.8,407.5,44,407,41.1,406z"
          />
          <g>
            <defs>
              <path id="SVGID_3_"
                d="M41.1,406l1.1,18.6h53.6v-5.3c0-3.6-2.4-6.7-5.9-7.6l-25.3-6.3c-3,1.3-7.5,2.1-12.5,2.1C47.8,407.5,44,407,41.1,406z"
              />
            </defs>
            <clipPath id="SVGID_4_">
              <use xlinkHref="#SVGID_3_" className={styles.st17} />
            </clipPath>
            <g className={styles.st7}>
              <g>
                <line className={styles.st3} x1="93.6" y1="406.4" x2="82.1" y2="413.2" />
                <line className={styles.st3} x1="83" y1="406.4" x2="73.4" y2="412" />
                <line className={styles.st3} x1="72.4" y1="406.4" x2="65.8" y2="410.3" />
              </g>
              <circle className={styles.st3} cx="39.5" cy="423" r="9.8" />
            </g>
          </g>

            <rect x="42.2" y="420.5" transform="matrix(-1 -4.488866e-11 4.488866e-11 -1 138.1917 845.0258)" className={styles.st4} width="53.8" height="4.1" />
          <ellipse className={styles.st1} cx="93.2" cy="219.4" rx="21.2" ry="20.5" />
          <ellipse className={styles.st1} cx="53.5" cy="219.4" rx="21.2" ry="20.5" />
          <polygon className={styles.st1} points="74.7,228.4 78,234.3 78.1,234.4 114.2,297.7 144.4,282.3 120,228.3 114.5,216 111.6,209.6 " />
          <polygon className={styles.st1} points="32.3,219.4 32.6,226.4 33.2,239.8 36,299 69.9,299 73.3,226.2 73.7,219.4 " />
          <ellipse className={styles.st1} cx="128.8" cy="289.2" rx="17.2" ry="17.3" />
          <polygon className={styles.st1} points="89.5,386.1 115.1,392.9 145.2,294.2 112.4,285.5 " />
          <polygon className={styles.st1} points="39.7,402.1 66.1,402.1 69.9,299 35.9,299 " />
          <polygon className={styles.st5} points="4.5,162.5 22.5,172.5 61.1,109 38,96.1 " />
          <polygon className={styles.st8} points="127.9,133.1 111.5,150.4 114.6,155.8 129.6,136.5 " />
          <polygon className={styles.st8} points="18.7,134.3 38.2,148.2 37.3,149.3 15.4,140.8 " />
          <polygon className={styles.st6} points="16.3,132.6 38.2,148.2 61.1,109 36.9,96.7 " />
          <path className={styles.st9}
            d="M35.8,101.8c0.1-5,2.9-9.4,7-10.8L57,85.9l3.8,4.4c2.2,2.6,4.5-20.8,7.9-20.8h10.5c3.2,0,4.6,22.8,6.9,20.4l5.1-3.4l12.8,4.6c4,1.4,6.9,5.8,7,10.8l4.8,117.1L32.3,220L35.8,101.8z"
          />

          <ellipse transform="matrix(0.9445 -0.3286 0.3286 0.9445 -54.2204 13.7547)" className={styles.st5} cx="13.6" cy="167.3" rx="10.3" ry="10.3" />
          <path className={styles.st0}
            d="M60.8,70.7l0.2,8.6l0.2,8.5c0,6.8,12.9,14.8,12.9,14.8s12.9-8,12.9-14.8l-0.2-9.1l-0.2-8c0-6.8-5.8-12.3-12.9-12.3c-3.6,0-6.8,1.4-9.1,3.6C62.2,64.2,60.8,67.3,60.8,70.7z"
          />
          <path className={styles.st8}
            d="M60.8,70.7l0.2,8.6c3.6,2.2,7.9,3.4,12.4,3.4c5,0,9.6-1.5,13.4-4l-0.2-8c0-6.8-5.8-12.3-12.9-12.3c-3.6,0-6.8,1.4-9.1,3.6C62.2,64.2,60.8,67.3,60.8,70.7z"
          />
          <path className={styles.st5}
            d="M48.8,34.2v19.6c0,13.6,11,24.6,24.6,24.6c13.6,0,24.6-11,24.6-24.6V34.2c0-8.6-4.4-16.2-11.1-20.6c-2.2-1.4-4.6-2.5-7.1-3.2c-2-0.5-4.1-0.8-6.3-0.8c-6.8,0-12.9,2.7-17.4,7.2c-3.9,3.9-6.5,9-7.1,14.8C48.8,32.4,48.8,33.3,48.8,34.2z"
          />
          <circle className={styles.st10} cx="84.5" cy="43" r="3.1" />
          <circle className={styles.st10} cx="62.6" cy="43" r="3.1" />
          <path className={styles.st11} d="M84.7,53.7c0,6.3-5.1,11.4-11.4,11.4S62,60,62,53.7" />
          <polygon className={styles.st12} points="32.5,223.8 116.9,221.3 115.8,218.9 32.3,219.4 " />
          <path className={styles.st6}
            d="M90.6,84.6l-15.1,17l2.8,8.4c0.7,1.1,2.4,1.2,3.1,0l14.1-22.3c0.4-0.5,0.2-1.1-0.3-1.4l-2.9-1.9C91.8,84.1,91.1,84.2,90.6,84.6z"
          />
          <path className={styles.st6}
            d="M57.4,84.6l15.1,17l-2.8,8.4c-0.7,1.1-2.4,1.2-3.1,0L52.5,87.7c-0.4-0.5-0.2-1.1,0.3-1.4l2.9-1.9C56.2,84.1,56.9,84.2,57.4,84.6z"
          />
          <path className={styles.st4}
            d="M39.5,398h27.8c0.2,0,0.4,0.2,0.4,0.4v4.5c0,0.2-0.2,0.4-0.4,0.4H39.5c-0.2,0-0.4-0.2-0.4-0.4v-4.5C39.1,398.2,39.3,398,39.5,398z"
          />
          <path className={styles.st4}
            d="M88.8,385l27.4,7.3c0.2,0.1,0.3,0.3,0.3,0.5l-1.2,4.3c-0.1,0.2-0.3,0.3-0.5,0.3l-27.4-7.3c-0.2-0.1-0.3-0.3-0.3-0.5l1.2-4.3C88.3,385,88.6,384.9,88.8,385z"
          />
          <polygon className={styles.st5} points="25.1,248.4 40.7,244.6 23.5,164.3 3.4,169.2 " />
          <circle className={styles.st5} cx="48.8" cy="47.4" r="5.5" />
          <circle className={styles.st5} cx="97.9" cy="47.4" r="5.5" />
          <path className={styles.st10}
            d="M98,55.6c-1.3,0-2.3-1-2.3-2.3V37.8c0-7.5-3.7-14.4-10-18.5c-1.9-1.3-4.1-2.2-6.4-2.8c-1.8-0.5-3.7-0.7-5.7-0.7c-5.9,0-11.4,2.3-15.6,6.5c-3.6,3.5-5.8,8.3-6.3,13.2c-0.1,0.8-0.1,1.5-0.1,2.4v15.6c0,1.3-1,2.3-2.3,2.3h0c-1.3,0-2.3-1-2.3-2.3V37.8c0-1,0-1.9,0.2-2.8c0.6-6.2,3.4-11.8,7.6-16c4.8-4.8,11.5-7.8,18.8-7.8c2.4,0,4.6,0.3,6.8,0.9c2.8,0.7,5.4,1.9,7.7,3.4c7.3,4.8,12.1,12.9,12.1,22.3v15.6C100.3,54.6,99.2,55.6,98,55.6L98,55.6z"
          />
          <ellipse transform="matrix(0.9889 -0.1484 0.1484 0.9889 -2.9204 10.1399)" className={styles.st10} cx="66.5" cy="24.6" rx="17.5" ry="8.6" />
          <path className={styles.st4} d="M41.1,186.3h64.6v-66.8c0-3.3-2.6-5.9-5.9-5.9H47c-3.3,0-5.9,2.6-5.9,5.9V186.3z" />
          <path className={styles.st13} d="M146,319.9H41.1V186.3h64.4l38.9,74.7c1,1.4,1.8,3,2.4,4.7l3.2,9.4c2.7,8,3.1,16.7,1,24.9L146,319.9z" />
          <path className={styles.st4} d="M52.3,126.6l6-1.5l-9-37.1c-0.1-0.3-0.4-0.5-0.7-0.4l-4.9,1.2c-0.3,0.1-0.5,0.4-0.4,0.7L52.3,126.6z" />
          <path className={styles.st4} d="M89,124.3l5.8,1.8L106,89.8c0.1-0.3-0.1-0.5-0.3-0.6l-4.9-1.5c-0.3-0.1-0.5,0.1-0.6,0.3L89,124.3z" />
          <path className={styles.st5}
            d="M37.4,265.1L37.4,265.1c5.2-1.3,8.3-6.5,7.1-11.7l-1.7-7c-0.9-3.6-4.5-5.8-8.1-4.9l-5.7,1.4c-3.6,0.9-5.8,4.5-4.9,8.1l1.7,7C27,263.2,32.3,266.4,37.4,265.1z"
          />

          <rect x="40.7" y="319.9" transform="matrix(-1 -4.494950e-11 4.494950e-11 -1 109.166 643.6332)" className={styles.st14} width="27.8" height="3.9" />
          <polygon className={styles.st14} points="103.7,323.8 136.2,323.8 137.4,319.9 104.6,319.9 " />
          <line className={styles.st15} x1="90.5" y1="37.6" x2="82.1" y2="35.3" />
          <line className={styles.st15} x1="56.8" y1="37.4" x2="65.2" y2="35.1" />
          <path className={styles.st9}
            d="M46.6,28.9c0.6-6.3,1.3-12.9,5.5-17.1c4.9-4.9,13.9-7,21.3-7c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c7.5,0,16.4,2.1,21.3,7c4.3,4.3,4.9,10.8,5.5,17.1c0.1,0.9,0.2,1.9,0.2,2.9v2.6c-8.3-5.3-17.7-7.8-27.2-7.7c-9.4-0.1-18.9,2.4-27.2,7.7v-2.6C46.4,30.8,46.4,29.8,46.6,28.9z"
          />
          <path className={styles.st9}
            d="M51.2,30.4c6.8-3,14.1-4.5,21.7-4.5h1.4c7.5,0,14.9,1.6,21.7,4.5c-0.5-4.8-1.3-12.8-4-15.5C88,11,80.1,9.2,73.9,9.2l-0.3,0c-0.2,0-0.3,0-0.4,0c-6.2,0-14.1,1.8-18,5.7C52.5,17.6,51.8,25.6,51.2,30.4z"
          />
          <path className={styles.st6}
            d="M45.1,36.2C45.1,36.2,45.1,36.2,45.1,36.2c0.6,0.7,1.5,0.9,2.1,0.3c0.4-0.3,0.7-0.6,1.1-0.9c1.2-1,2.5-1.9,3.8-2.7c13.4-8.3,29.7-8.3,43.1,0c1.7,1,3.3,2.2,4.8,3.5c0,0,0.1,0,0.1,0.1c0.7,0.5,1.6,0.4,2.1-0.3c0,0,0,0,0,0c0.6-0.7,0.4-1.9-0.3-2.4c-0.6-0.5-1.2-1-1.8-1.4c-0.1,0-0.1-0.1-0.2-0.1c-15.6-11.7-36-11.9-51.7-0.7c-0.1,0-0.1,0.1-0.2,0.1c-1,0.7-1.9,1.4-2.8,2.1C44.6,34.4,44.5,35.5,45.1,36.2z"
          />
          <ellipse className={styles.st6} cx="73.6" cy="4.8" rx="3" ry="2.1" />
          <path className={styles.st4}
            d="M48,136.6h13.4c0.2,0,0.3-0.1,0.3-0.3v-4.7c0-0.2-0.1-0.3-0.3-0.3H48c-0.2,0-0.3,0.1-0.3,0.3v4.7C47.7,136.5,47.8,136.6,48,136.6z"
          />
          <path className={styles.st16}
            d="M48,135h13.4c0.2,0,0.3-0.1,0.3-0.3V130c0-0.2-0.1-0.3-0.3-0.3H48c-0.2,0-0.3,0.1-0.3,0.3v4.7C47.7,134.9,47.8,135,48,135z"
          />
          <path className={styles.st11} d="M74.2,47.4c-1.9-0.5-3.8,0.3-4.3,1.8c-0.4,1.5,0.8,3.2,2.7,3.7" />
        </g>
        </svg>
      </div>
    );
  }
}

Employee.propTypes = {
  className: PropTypes.string,
};

export default Employee;



// WEBPACK FOOTER //
// ./src/components/sign_up/sign_up_carousel/shared/employee/index.jsx